export const environment = {
  production: false,
  logoff : true,
  logo : '/assets/np-logo-white.svg',
  favicon: '/assets/favicon-hs.svg',
  title: 'Propeye',
  maintitle: '',
  editortheme: 'vs'
};
